/* Custom Ring Builder - Demo logic */
(function() {
  'use strict';

  function ready(fn){
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function layoutArc(container, options) {
    // Position children along an arc
    const items = Array.from(container.children);
    if (!items.length) return;
    const rect = container.getBoundingClientRect();
    const cx = rect.width / 2; // center x inside container
    const cy = rect.height;    // base y; top arc uses smaller radius, bottom arc inverted

    const { radius = Math.min(rect.width, rect.height) * 0.85, startDeg = 200, endDeg = -20 } = options || {};
    const start = (startDeg * Math.PI) / 180;
    const end = (endDeg * Math.PI) / 180;

    const steps = items.length - 1;
    items.forEach((el, i) => {
      const t = steps === 0 ? 0.5 : i / steps;
      const a = start + (end - start) * t;
      const x = cx + radius * Math.cos(a);
      const y = cy + radius * Math.sin(a);
      el.style.left = x + 'px';
      el.style.top = y + 'px';
    });
  }

  function fadeSwap(img, src) {
    if (!img || !src || img.getAttribute('src') === src) return;
    img.style.opacity = '0';
    const onEnd = () => {
      img.removeEventListener('transitionend', onEnd);
      img.src = src;
      requestAnimationFrame(() => (img.style.opacity = '1'));
    };
    img.addEventListener('transitionend', onEnd);
  }

  ready(function initRingBuilder(){
    const sections = document.querySelectorAll('.ring-builder');
    if (!sections.length) return;

    sections.forEach(section => {
      // Support both rb-* structure and your current stones-arc/bases-arc markup
      const arcTop = section.querySelector('.rb-arc--top') || section.querySelector('.stones-arc');
      const arcBottom = section.querySelector('.rb-arc--bottom') || section.querySelector('.bases-arc');
      const imgStone = section.querySelector('[data-ring-stone]') || section.querySelector('#stone-layer');
      const imgBase = section.querySelector('[data-ring-base]') || section.querySelector('#base-layer');
      const labelStone = section.querySelector('[data-label-stone]') || section.querySelector('#stone-label');
      const labelBase = section.querySelector('[data-label-base]') || section.querySelector('#base-label');

      // Hidden inputs for properties: create on the main product form if missing
      const productForm = document.querySelector('form[action*="/cart/add"], form[action*="/cart"]');
      let inputStone = section.querySelector('[data-input-stone]');
      let inputBase = section.querySelector('[data-input-base]');
      if (!inputStone && productForm) {
        inputStone = document.createElement('input');
        inputStone.type = 'hidden';
        inputStone.name = 'properties[Pietra]';
        inputStone.setAttribute('data-input-stone', '');
        productForm.appendChild(inputStone);
      }
      if (!inputBase && productForm) {
        inputBase = document.createElement('input');
        inputBase.type = 'hidden';
        inputBase.name = 'properties[Base]';
        inputBase.setAttribute('data-input-base', '');
        productForm.appendChild(inputBase);
      }

      function relayout() {
        if (arcTop) layoutArc(arcTop, { startDeg: 205, endDeg: -25, radius: arcTop.clientWidth * 0.42 });
        if (arcBottom) layoutArc(arcBottom, { startDeg: 25, endDeg: 155, radius: arcBottom.clientWidth * 0.42 });
      }
      relayout();
      window.addEventListener('resize', relayout);

      // Initialize selected defaults
      const firstStone = arcTop?.querySelector('.rb-swatch--stone, img.stone-img');
      const firstBase = arcBottom?.querySelector('.rb-swatch--base, img.base-img');
      if (firstStone) firstStone.classList.add('is-selected');
      if (firstBase) firstBase.classList.add('is-selected');

      section.addEventListener('click', (e) => {
        const btn = e.target.closest('.rb-swatch, img.stone-img, img.base-img');
        if (!btn) return;
        let kind = btn.dataset.kind; // 'stone' or 'base'
        if (!kind) {
          if (btn.classList.contains('stone-img')) kind = 'stone';
          else if (btn.classList.contains('base-img')) kind = 'base';
        }
        const name = btn.dataset.name || '';
        const src = btn.dataset.src || btn.dataset.stone || btn.dataset.base || '';

        // Toggle selected class within its arc
        const groupSel = kind === 'stone' ? '.rb-swatch--stone, img.stone-img' : '.rb-swatch--base, img.base-img';
        section.querySelectorAll(groupSel).forEach(el => el.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        if (kind === 'stone') {
          labelStone && (labelStone.textContent = name);
          inputStone && (inputStone.value = name);
          fadeSwap(imgStone, src);
        } else if (kind === 'base') {
          labelBase && (labelBase.textContent = name);
          inputBase && (inputBase.value = name);
          fadeSwap(imgBase, src);
        }
      });

      // Nothing special on submit: properties are synced via hidden inputs on the main form
    });
  });
})();
